/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Apr 04 2024
 **/

import { useState } from "react";

import { useChatMessageActions } from "@/frameworks/core/chat";
import { useChatDataStore } from "@/modules/chat/store";

export default function useUpdateMessage(roomID: string) {
	const { updateMessage: updateMessageCommand } = useChatMessageActions();
	const [messageToUpdate, setMessageToUpdate] = useState<ChatServices.Format2.Message | null>(null);

	const stopUpdateMessage = () => {
		setMessageToUpdate(null);
		useChatDataStore.getState().change_updating_state(roomID, false);
	};

	const updateMessage = (
		message: ChatServices.Format2.Message,
		{ messageID, roomID, searchMessage }: { messageID: string; roomID: string; searchMessage: string }
	) => {
		updateMessageCommand({
			targetMessageID: messageID,
			channelID: roomID,
			contents: JSON.stringify(message),
			searchMessage
		});

		stopUpdateMessage();
	};

	const startUpdateMessage = (message: ChatServices.Format2.Message) => {
		setMessageToUpdate(message);
		useChatDataStore.getState().change_updating_state(roomID, true);
	};

	return { messageToUpdate, updateMessage, stopUpdateMessage, startUpdateMessage };
}
